import { useEffect, useState } from "react"
import style from "../task-creator.module.css";
import BtnDelSvg from "../utils/btn-del-svg";
import TextArea from "./textArea";


export function EqualAnswer({id, change,deleteHandler,defaultValue}) {
    const [text, setText] = useState(defaultValue?.name||'')
    const [equalText, setEqualText] = useState(defaultValue?.equal||'')

    function changeHandler(e) {
        e.target.id === 'text' && setText(e.target.value)
        e.target.id === 'equal' && setEqualText(e.target.value)
    }

    useEffect(() => {
        const answer = {
            name: text,
            equal: equalText,
        }
        change(answer, id)
    }, [text, equalText])

    return (
        <div className={style.task_line_box}>
            <h2>Ответ</h2>

                <TextArea value={text} id="text" changeHandler={changeHandler}/>
                <TextArea value={equalText} id="equal" changeHandler={changeHandler}/>
            <button className={style.task_answer_del} onClick={() => deleteHandler(id)}><BtnDelSvg/></button>
        </div>
    )
}